import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { openDialog, closeDialog } from '../../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { OperacionesTransileView } from '../components/OperacionesTransileView'
import { OperacionEliminarTransile } from '../operacionEliminarTransile/containers/OperacionEliminarTransile'
import { OperacionNuevoTransile } from '../operacionNuevoTransilo/containers/OperacionNuevoTransile'

export const OperacionesTransile = connect(null, { openDialog, closeDialog })(
  memo(({ silo, openDialog, closeDialog }) => (
    <OperacionesTransileView
      silo={silo}
      openDialogNuevoTransile={() => openDialog(() => <OperacionNuevoTransile silo={silo} />, 'TRANSILE_SILO')}
      openDialogEliminarUltimoTransile={() => openDialog(() => <OperacionEliminarTransile silo={silo} />, 'ELIMINAR_TRANSILE_SILO')}
      cancelar={useCallback(() => {
        closeDialog('OPERACIONES_DE_TRANSILE_DE_SILO')
      }, [closeDialog])}
    />
  ))
)
